export default __webpack_public_path__ + "static/media/pink-circle.b2a14122.svg";